const COLORS = {

    PRIMARY_FONT: '#000000',
    PRIMARY_BACKGROUND: '#FFFFFF',
    ACTIVE_LINK: 'grey',
    HOVER_LINK: '#005FA6',
    // HOVER_LINK: '#009DFF',
};

export default COLORS;